import { render } from "./THticket.vue?vue&type=template&id=0c5ff563&scoped=true"
import script from "./THticket.vue?vue&type=script&lang=js"
export * from "./THticket.vue?vue&type=script&lang=js"

import "./THticket.vue?vue&type=style&index=0&id=0c5ff563&lang=scss&scoped=true"

import exportComponent from "D:\\workCode\\PC\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c5ff563"]])

export default __exports__